export default __webpack_public_path__ + "static/media/movie-furo.ea255bf6.mp4";